// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'

// gets all the antenna companies from redux
// NOTE: this does not fetch antenna companies itself.
// that is handled by a parent calling fetchAndAddAntennaSettings.

// NOTE: this component must be assigned async validate by redux-form.

const AntennaCompanies = ({ companies, handleSelection, idRoot, name }) => (
  <Field
    component={AutoSuggest}
    handleSelection={handleSelection}
    id={`${idRoot}-antenna-company`}
    label={`Manufacturer`}
    name={name || 'company'}
    optionKey={`companyName`}
    staticSuggestions={companies} />
)

AntennaCompanies.propTypes = {
  companies: object.isRequired,
  handleSelection: func.isRequired,
  idRoot: string.isRequired,
  name: string,
}

const mapStateToProps = ({ domain }) => ({
  companies: domain.get('antennaCompanies'),
})

export default connect(
  mapStateToProps,
)(AntennaCompanies)
